import payable from "./payable";

export default {
  payable
};



// WEBPACK FOOTER //
// ./src/store/modules/payables/index.js